import { t } from 'i18next';

import { isUk } from 'services/currentCountry';
import { getRoutesUri } from 'services/generic';
import { ENV_COUNTRY } from 'settings/env';

type NavLinkItem = {
  to: string;
  label: string;
  titleActiveMenu?: string;
  classname?: boolean;
  logout?: boolean;
  lng?: string;
};

const Navlink: NavLinkItem[] = [
  {
    to: getRoutesUri('customerAccountOrderHistory') as string,
    label: t('LABEL_MYACCOUNT_ORDER'),
    titleActiveMenu: 'history',
  },
  {
    to: getRoutesUri('customerAccountInformation') as string,
    label: t('LABEL_PERSONALINFORMATION_TITLE'),
    titleActiveMenu: 'informations',
  },
  {
    to: getRoutesUri('customerAccountPersonalAccount') as string,
    label: t('LABEL_MYACCOUNT_PERSONALPAYONLINE'),
    lng: ENV_COUNTRY,
    titleActiveMenu: 'personalAccount',
  },
  {
    to: getRoutesUri('customerAccountNewsletter') as string,
    label: t('LABEL_SUMMARY_SUBSCRIPTION_EDIT'),
    titleActiveMenu: 'newsletter',
  },
];

if (!isUk()) {
  Navlink.push({
    to: getRoutesUri('customerAccountCatalogRequest') as string,
    label: t('LABEL_MYACCOUNT_CATALOG'),
    titleActiveMenu: 'catalogRequest',
  });
}

Navlink.push({
  classname: true,
  to: getRoutesUri('customerAccountLogOutSuccess') as string,
  logout: true,
  label: t('LABEL_MYACCOUNT_SIGNOUT'),
});

export { Navlink };
